import React, {forwardRef} from "react";
import {FaRss} from "react-icons/fa6";
import {useTranslation} from "react-i18next";
import {Tooltip} from "@material-tailwind/react";
import {enqueueSnackbar} from "notistack";
import {textLine} from "../../translations/textDefault";

type IconWithRefProps = {
    className?: string;
    onClick?: () => void;
};

const IconWithRef = forwardRef<HTMLSpanElement, IconWithRefProps>(({ className, onClick }, ref) => (
    <span ref={ref} className={className} onClick={onClick}>
        <FaRss className={'cursor-pointer'} />
    </span>
));

interface Props {
    onClick?: () => void;
}
export default function InfoOnline({onClick}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    return (
        <>
            <Tooltip
                className={"bg-header font-semibold"}
                content={t('online-consultation')}
            >
                <IconWithRef className={'text-success'} {...{onClick}} />
            </Tooltip>
        </>
    )
}

export function msjLine(service?: string) {
    return enqueueSnackbar(
        <div className={'max-w-[300px]'}>
            {`${service ? '(' + service + ') ' : ''}${textLine}`}<FaRss/>
        </div>, {variant: 'info'});
}
